import { logger } from '@fe/core';
import { UpdateSettingType } from '../../../common/enums';
import { SettingsService, UpdateUserSettingRequestModel } from '../../../services/axios/axios-api-v2-generated';
import { SETTINGS_DEFINITIONS, SyncType } from '../../../services/settings-service';
import { setSetting, updateSetting } from '../slices/settings-slice';
import { startAppListening } from './listener-middleware';
import { workspaceSwitchView } from '../slices/workspace-slice';

export function startSettingsListen() {
    startAppListening({
        actionCreator: updateSetting,
        effect: async (action, api) => {
            const definition = SETTINGS_DEFINITIONS[action.payload.key];
            if (definition.sync === SyncType.local) {
                localStorage.setItem(definition.key, JSON.stringify(action.payload.value));
                return;
            }

            const serializedValue = JSON.stringify(action.payload.value);
            const request: UpdateUserSettingRequestModel = {};
            if (definition.defaultValueJson === serializedValue) {
                request.type = UpdateSettingType.delete;
                request.key = definition.key;
            } else {
                request.type = UpdateSettingType.update;
                request.item = {
                    key: definition.key,
                    value: serializedValue
                };
            }
            try {
                await api.pause(SettingsService.updateUserSettingAsync({ body: request }, { withAuthorization: true }));
            } catch (err) {
                logger.trackException(err);
                logger.warn('Failed to sync settings');
            }
        }
    });

    startAppListening({
        actionCreator: workspaceSwitchView.fulfilled,
        effect: (action, api) => {
            api.dispatch(setSetting('selectedUdView', action.payload.view.id));
        }
    });
}
